import { Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { useEffect, useState } from 'react'
import { ChangePassword } from '../../models/changePswd';
import { rootStore } from '../../redux/root/root.store';
import { DraggableModal } from '../DraggableModal'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAuthState } from '../../redux/slices/authSlice';
import InputPassword from '../inputs/inputPassword';

interface IProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (e: ChangePassword) => Promise<boolean>;
}

enum FormField{
  user_id,
  old_password,
  new_password,
  confirm_new_password
}

export const ChangePasswordModal = (props: IProps) => {
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const {t} = useTranslation()
  const { roles } = useSelector(getAuthState);

  const getMaxPasswordLength = (roles: Array<any>) => {
    return Math.max(...roles.map(role => role.passwordLength || 0));
  }

  const currPassLen = roles ? getMaxPasswordLength(roles) : null;

  useEffect(() => {
    if (props.show) setFieldsFromEntity();
  }, [props.show]);
  
  function setFieldsFromEntity(): void {
    form.setFields([
      { name: FormField.new_password, value: "" },
      { name: FormField.old_password, value: "" },
      { name: FormField.confirm_new_password, value: "" },
    ]);
  }
  function setEntityFromFields(): ChangePassword {
    let changePass = new ChangePassword();
    changePass.pin = rootStore.getState().authSlice.pin;
    changePass.oldPassword = form.getFieldValue(FormField.old_password);
    changePass.password = form.getFieldValue(FormField.new_password);
    return changePass;
  }

  async function handleSubmit() {
    setLoading(true);
    const changedPassword = setEntityFromFields();
    const result = await props.onSubmit(changedPassword);
      if (result) props.onHide();
    try {
      setEntityFromFields();
    } finally {
      setLoading(false);
    }
  }

  return (
    <DraggableModal
      title={t('auth.changing_password')}
      visible={props.show}
      onSubmit={handleSubmit}
      onCancel={props.onHide}
      submitLoading={loading}
    >
      <Form
        form={form}
        layout='vertical'
      >
        <Form.Item
          label={t('auth.currentPassword')}
          name={FormField.old_password}
          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
        >
          <Input.Password placeholder={t('auth.currentPassword')} />
        </Form.Item>
        <Form.Item
          label={t('auth.new_password')}
          name={FormField.new_password}
          rules={[
            { required: true, message: t("msg.fill_in_the_field") },
            { pattern: new RegExp(/^.*(?=.{8,})(?=.*[a-zA-Z])(?=.*\d)(?=.*[!#$%&? ".]).*$/, 'g'), message: t('auth.passwordValidationErrorMessage') }
          ]}
          hasFeedback
        >
          <InputPassword passwordLength={currPassLen} />
        </Form.Item>
        <Form.Item
          label={t('auth.confirm_password')}
          name={FormField.confirm_new_password}
          dependencies={[FormField.new_password]}
          hasFeedback
          rules={[
            { required: true, message: t("msg.fill_in_the_field") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if(!value || getFieldValue(FormField.new_password) === value) {
                  return Promise.resolve();
                }

                return Promise.reject(new Error(t('msg.dont_match_password')));
              }
            })
          ]}
        >
          <Input.Password placeholder={t('auth.confirm_password')}/>
        </Form.Item>
      </Form>
    </DraggableModal>
  )
}
